var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var SHOULD_DEDUPE_OPTIONAL_MODIFIERS_BETWEEN_GROUPS = false;
var normalizeModifierName = function (value) { return value.trim().toLocaleLowerCase(); };
export var buildIncludedModifierNameSet = function (includedModifierIds, modifiers) {
    var includedNames = new Set();
    includedModifierIds.forEach(function (modifierId) {
        var _a;
        var modifierName = (_a = modifiers[modifierId]) === null || _a === void 0 ? void 0 : _a.name;
        if (!modifierName) {
            return;
        }
        includedNames.add(normalizeModifierName(modifierName));
    });
    return includedNames;
};
export var filterOptionalModifierGroups = function (groups, modifiers, includedModifierNames, shouldDedupeAcrossOptionalGroups) {
    if (shouldDedupeAcrossOptionalGroups === void 0) { shouldDedupeAcrossOptionalGroups = SHOULD_DEDUPE_OPTIONAL_MODIFIERS_BETWEEN_GROUPS; }
    var seenOptionalModifierNames = new Set();
    return groups
        .map(function (group) {
        var filteredModifierIds = (group.modifiers || []).filter(function (modifierId) {
            var _a;
            var modifierName = (_a = modifiers[String(modifierId)]) === null || _a === void 0 ? void 0 : _a.name;
            if (!modifierName) {
                return true;
            }
            var normalizedModifierName = normalizeModifierName(modifierName);
            if (includedModifierNames.has(normalizedModifierName)) {
                return false;
            }
            if (!shouldDedupeAcrossOptionalGroups) {
                return true;
            }
            if (seenOptionalModifierNames.has(normalizedModifierName)) {
                return false;
            }
            seenOptionalModifierNames.add(normalizedModifierName);
            return true;
        });
        return __assign(__assign({}, group), { modifiers: filteredModifierIds });
    })
        .filter(function (group) { return (group.modifiers || []).length > 0; });
};
